const itemsList = {
  hu: {
    // GeneratedItemsList
    itemsTab: "Elemek",
    settingsTab: "Beállítások",
    noSettings: "Nincs elérhető beállítás",
    selectAll: "Összes kijelölése",
    deselectAll: "Összes kijelölés törlése",
    itemCount: "db",
    objPrefix: "Obj #",

    // Dimension labels in settings
    dimWidth: "Szélesség",
    dimHeight: "Magasság",
    dimDepth: "Mélység",

    // Item
    itemNamePlaceholder: "Név",
    itemDetailsPlaceholder: "Részletek",
    itemNoColor: "Nincs szín",
    itemColor: "Szín",
    itemRotatable: "Forgatható",
    itemNotRotatable: "Nem forgatható",
    itemDeleteConfirm: "Biztosan törli ezt az elemet?"
  },
  ro: {
    itemsTab: "Piese",
    settingsTab: "Setări",
    noSettings: "Nu există setări disponibile",
    selectAll: "Selectează toate",
    deselectAll: "Deselectează toate",
    itemCount: "buc",
    objPrefix: "Obj #",

    dimWidth: "Lățime",
    dimHeight: "Înălțime",
    dimDepth: "Adâncime",

    itemNamePlaceholder: "Nume",
    itemDetailsPlaceholder: "Detalii",
    itemNoColor: "Fără culoare",
    itemColor: "Culoare",
    itemRotatable: "Rotabil",
    itemNotRotatable: "Nerotabil",
    itemDeleteConfirm: "Sigur doriți să ștergeți acest element?"
  },
  en: {
    itemsTab: "Items",
    settingsTab: "Settings",
    noSettings: "No settings available",
    selectAll: "Select all",
    deselectAll: "Deselect all",
    itemCount: "pcs",
    objPrefix: "Obj #",

    dimWidth: "Width",
    dimHeight: "Height",
    dimDepth: "Depth",

    itemNamePlaceholder: "Name",
    itemDetailsPlaceholder: "Details",
    itemNoColor: "No color",
    itemColor: "Color",
    itemRotatable: "Rotatable",
    itemNotRotatable: "Not rotatable",
    itemDeleteConfirm: "Are you sure you want to delete this item?"
  }
};

export default itemsList;
